const importAll = (require) =>
  require.keys().reduce((acc, next) => {
    acc[next.replace('./', '').split('.')[0]] = require(next);
    return acc;
  }, {});

export const icons = importAll(require.context('./icons', false, /\.(png|jpe?g|svg)$/));
export const backgrounds = importAll(require.context('./backgrounds', false, /\.(png|jpe?g|svg)$/));
export const illustrations = importAll(require.context('./illustrations', false, /\.(png|jpe?g|svg)$/));
export const brand = importAll(require.context('./brand', false, /\.(png|jpe?g|svg)$/));
export const logos = importAll(require.context('./logos', false, /\.(png|jpe?g|svg)$/));
export const svgImages = importAll(require.context('./svg/images', false, /\.(png|jpe?g|svg)$/));
